import React from 'react';
import { Grid } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import GridColumnLayout from 'components/layout/GridColumnLayout';
import PreferencesAccessibility from './PreferencesAccessibility';
import PreferencesClassesAndGroups from './PreferencesClassesAndGroups';

const PreferencesWrapper: React.FC = () => {
  const classes = useStyles();

  return (
    <GridColumnLayout
      containerProps={{ style: { maxWidth: 1200, flexWrap: 'wrap' } }}
      gridContainerProps={{ className: classes.root, wrap: 'wrap' }}
      classes={{ root: classes.root }}
    >
      <Grid container spacing={3} className={classes.root}>
        <PreferencesAccessibility />
        <PreferencesClassesAndGroups />
      </Grid>
    </GridColumnLayout>
  );
};

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    marginTop: '8px',
  },
}));

export default PreferencesWrapper;
